import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { withLatestFrom, mergeMap, tap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ReportsService } from 'src/app/modules/report-components/services/report.service';
import * as fromActions from './anonymous-report.actions';
import * as fromSelectors from './anonymous-report.selectors';
import { Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { AuthService } from '../../modules/auth/services/auth.service';

@Injectable()
export class AnonymousReportEffects {
  constructor(private actions$: Actions, private reports: ReportsService, private store: Store<{ router: RouterReducerState }>) {}

  loadAnonymousReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.loadReport),
      withLatestFrom(this.store.select(fromSelectors.selectAnonymousToken)),
      tap(([_, token]) => AuthService.setReportToken(token)),
      mergeMap(([_, token]) =>
        this.reports.getReportByToken(token).pipe(
          tap(res => {
            if (res.error) {
              throw new Error(res.error);
            }
          }),
          map(res => fromActions.setCurrentReport({ report: res.data.report, cache: false, user: res.data.user })),
          catchError(error => of(fromActions.reportLoadError({ error: error.message }))),
        ),
      ),
    ),
  );
}
